import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { StaffDtoSchema } from '../contracts';

const UpdateStaffByIdRequestDtoSchema = z.object({
  id: z.number(),
  // ALIS staff: the hourly-or-salary rate. Sling staff: only the annual salary of a salaried person.
  wageRate: z.number().optional(),
  wageType: z.enum(['HOURLY', 'SALARY']).optional(),
  annualSalary: z.number().optional(),
  lastReviewAt: z.coerce.date(),
});

const UpdateStaffByIdResponseDtoSchema = StaffDtoSchema;

export type UpdateStaffByIdRequestDto = z.infer<
  typeof UpdateStaffByIdRequestDtoSchema
>;
export type UpdateStaffByIdResponseDto = z.infer<
  typeof UpdateStaffByIdResponseDtoSchema
>;

export const updateStaffById = (
  dto: UpdateStaffByIdRequestDto,
  config?: AxiosRequestConfig<UpdateStaffByIdRequestDto>
) => {
  const { id, ...data } = UpdateStaffByIdRequestDtoSchema.parse(dto);

  return api
    .patch(`/staff/${id}`, data, config)
    .then(responseContract(UpdateStaffByIdResponseDtoSchema));
};
